<template>
  <v-container fluid class="pa-6"
               style="max-width: 83%;"
  >

    <v-row>
      <v-col cols="12">

        <v-card
            v-if="proceduresStore.procedureDataForm"
            flat
            color="transparent"
        >
          <!-- TITLE -->
          <v-card-title class="main_color--text">
            {{ processStore.processName }}
            <span class="ml-2 font-weight-regular">
              (Trámite {{ procedureMeta.tramite_id }})
            </span>
          </v-card-title>

          <!-- STEPPER -->
          <v-container class="pa-0">
            <TaskSteps :current-task="getCurrentStep()" />
          </v-container>

          <!-- FORM BOX -->
          <v-card
              class="mt-6 pa-6"
              elevation="2"
              rounded="xl"
          >
            <Form procedure-action="create" />
          </v-card>

        </v-card>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex";
    import {procedureCreateRequest, procedureTaskStepsRequest} from "../api/models";

    import Form from '../components/Procedure/Form'
    import TaskSteps from './../components/Procedure/TaskSteps'

    export default {
        data(){
          return {
              currentTask: 1
          }
        },
        components: {
            Form, TaskSteps
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures, processStore: state => state.processes}),
            ...mapGetters('procedures', ['procedureForm', 'procedureMeta'])
        },

        created() {
            //VueX call
            this.clearProcedureForm()
            this.processStore.processName = null

            this.$gtag.event('crear', { method: 'Google' })
        },

        mounted() {
            let routeName = this.$route.name

            //Sart new procedure
            if (routeName === 'procedure_create'){
                this.$gtag.event('tramite_crear', { method: 'Google' }) // Google Analytics
                this.initProcedureCreation()
            } // Continue procedure
            else if (routeName === 'procedure_continue'){
                this.$gtag.event('tramite_continuar', { method: 'Google' }) // Google Analytics
                this.initProcedureContinue()
            }// Continue procedure
            else if (routeName === 'procedure_view'){
                this.$gtag.event('tramite_Ver', { method: 'Google' }) // Google Analytics
                this.initProcedureView()
            }
        },

        updated() {
            this.$nextTick(() => {
                if (this.proceduresStore.procedureDataForm != null){
                    if (this.processStore.processName == null){
                        this.fetchProcessName()
                    }else if (this.proceduresStore.taskSteps == null){
                        this.fetchTaskSteps()
                    }
                }
            })
        },

        methods: {
            ...mapActions('procedures', [
                'createProcedure', 'getProcedureTaskSteps', 'continueProcedure',
                'viewProcedure', 'clearProcedureForm'
            ]),
            ...mapActions('processes', ['getProcessDetails']),

            initProcedureCreation(){
                let request = procedureCreateRequest()
                request.processId = this.$route.params.processId

                //Call from VueX
                this.createProcedure(request)
            },

            initProcedureContinue(){
                //Call from VueX
                this.continueProcedure(this.$route.params.stageId)
            },

            initProcedureView(){
                //Call from VueX
                this.viewProcedure(this.$route.params.stageId)
            },

            fetchProcessName(){
                //Call from Vuex: Get process details
                this.getProcessDetails(this.procedureMeta.proceso_id)
            },

            fetchTaskSteps(){
                let request = procedureTaskStepsRequest()
                request.stageId = this.procedureMeta.etapa_id
                request.taskId = this.procedureMeta.tarea_id

                //Call from VueX: get task steps to show on Header
                this.getProcedureTaskSteps(request)
            },

            getCurrentStep(){
                let currentIndex = 0
                if (this.proceduresStore.taskSteps != null){
                    this.proceduresStore.taskSteps.forEach((step, index) => {
                        if (step.formulario_id == this.procedureMeta.formulario_id){
                            currentIndex = (index + 1)
                            return
                        }
                    })
                }

                return currentIndex
            }

        }
    };
</script>

<style scoped>

</style>
